import { render, staticRenderFns } from "./TextShape.vue?vue&type=template&id=43a67cdc&scoped=true&"
import script from "./TextShape.vue?vue&type=script&lang=js&"
export * from "./TextShape.vue?vue&type=script&lang=js&"
import style0 from "./TextShape.vue?vue&type=style&index=0&id=43a67cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a67cdc",
  null
  
)

export default component.exports